import { CoreSetupAuditTrailViewsName } from './name';
import { createRemoveCollectionSyncSlice } from '@sonar-software/xuder';
import { DeleteSetupAuditTrailViewsRequest } from '@api';
import { getCoreSetupAuditTrailViewsSlice } from './get';

export const removeCoreSetupAuditTrailViewsSyncSlice = createRemoveCollectionSyncSlice({
	hasRequest: true,
	name: CoreSetupAuditTrailViewsName,
	state: getCoreSetupAuditTrailViewsSlice.asyncState,
	target: (request: DeleteSetupAuditTrailViewsRequest) => (view) => view.id === request.id
});
